import React, { useState } from 'react';
import { Drawer, Text } from 'components/Elements';
import { ProofOfTransaction } from './ProofOfTransaction';
import { useChangeTransactionStatus } from '../api/changeTransactionStatus';
import { TransactionDrawerDetails } from './transactionDrawer/TransactionDrawerDetails';
import { TransactionDrawerFooter } from './TransactionDrawerFooter';

export const TransactionDrawer = ({ isOpen, onClose, transaction }) => {
  const [displayProofOfTransaction, setDisplayProofOfTransaction] =
    useState(false);
  const [localStatus, setLocalStatus] = useState(transaction?.status);
  const [actionMessage, setActionMessage] = useState('');
  const [isAcceptLoading, setIsAcceptLoading] = useState(false);
  const [isDenyLoading, setIsDenyLoading] = useState(false);


  const { mutate: updateTransactionStatus, isLoading } =
    useChangeTransactionStatus();

  if (!transaction) return null;

  const handleProofOfTransactionClick = () => {
    setDisplayProofOfTransaction(!displayProofOfTransaction);
  };

  
  const handleClose = () => {
    setDisplayProofOfTransaction(false);
  };

  const handleApproveTransaction = () => {
    setIsAcceptLoading(true);
    updateTransactionStatus(
      {
        data: {
          id: transaction.id,
          status: 'successful',
        },
      },
      {
        onSuccess: () => {
          setLocalStatus('successful');
          setActionMessage('✅ Transaction approved successfully.');
          setIsAcceptLoading(false);
        },
      }
    );
  };

  const handleDenyTransaction = () => {
    setIsDenyLoading(true);
    updateTransactionStatus(
      {
        data: {
          id: transaction.id,
          status: 'failed',
        },
      },
      {
        onSuccess: () => {
          setLocalStatus('failed');
          setActionMessage('❌ Transaction has been denied.');
          setIsDenyLoading(false);
        },
      }
    );
  };

  const getTransactionComponent = () => {
    const { transactionType, transactionMethod } = transaction;
    

    const components = {
      Deposit: {
        merchantPay: TransactionDrawerDetails,
        mobilemoney: TransactionDrawerDetails,
        manualBank: TransactionDrawerDetails,
        admin: TransactionDrawerDetails,
      },
      Withdraw: {
        mobilemoney: TransactionDrawerDetails,
        manualbank: TransactionDrawerDetails,
        admin: TransactionDrawerDetails,
      },
      Swap: {
        default: TransactionDrawerDetails,
      },
      Transfer: {
        default: TransactionDrawerDetails,
      },
    };

    const typeMap = components[transactionType];
    if (!typeMap) return null;

    const ComponentToRender = typeMap[transactionMethod] || typeMap.default;

    return ComponentToRender ? (
      <ComponentToRender transaction={transaction} />
    ) : null;
  };

  return (
    <Drawer
      title={
        displayProofOfTransaction
          ? 'Proof of Transaction'
          : actionMessage
          ? 'Status Update'
          : 'Transaction Details'
      }
      isOpen={isOpen}
      onClose={() => {
        setActionMessage('');
        setDisplayProofOfTransaction(false);
        onClose();
      }}
      renderFooter={() =>
        !actionMessage && (
          <TransactionDrawerFooter
            actionMessage={actionMessage}
            displayProofOfTransaction={displayProofOfTransaction}
            handleApproveTransaction={handleApproveTransaction}
            handleClose={handleClose}
            handleProofOfTransactionClick={handleProofOfTransactionClick}
            handleDenyTransaction={handleDenyTransaction}
            acceptIsLoading={isLoading}
            denyIsLoading={isLoading}
            transaction={transaction}
          />
        )
      }
      size="lg"
    >
      {displayProofOfTransaction ? (
        <ProofOfTransaction imgSrc={transaction.summary} />
      ) : actionMessage ? (
        <div className="text-center p-6 rounded-xl bg-white/30 backdrop-blur-md shadow-md">
          <Text variant="h5" className="text-green-700 dark:text-green-400">
            {actionMessage}
          </Text>
          <p className="text-sm text-gray-600 mt-2">
            This transaction has been processed. You may close this drawer.
          </p>
        </div>
      ) : (
        getTransactionComponent()
      )}
    </Drawer>
  );
};
